import { FederalStates, type FederalStateKey } from '../../types/reports.js';

/**
 * Alphabetische Anzeigeordnung der 16 Bundeslaender (D-29) -- reine Anzeigeableitung.
 *
 * `FederalStates` selbst bleibt in seiner Regionsreihenfolge (Nord -> Ost -> West -> Sued)
 * bestehen, weil die Auswertungen (FormularABCalculator, EvaluationHandler) darauf aufsetzen.
 * Diese Liste sortiert nur eine Kopie der Schluessel fuer die Anzeige in `FormularABForm`; das
 * Datenmodell, die API und der Save-Payload sind davon unberuehrt.
 *
 * Deutsche Kollation (zweiter Parameter `'de'`) ist Pflicht statt eines einfachen
 * `<`-Vergleichs: ein reiner String-Vergleich sortiert Umlaute nach Unicode-Codepoint und wuerde
 * "Thüringen" damit falsch einordnen.
 */
export const orderedFederalStateKeys: FederalStateKey[] = (
  Object.keys(FederalStates) as FederalStateKey[]
).sort((a, b) => FederalStates[a].localeCompare(FederalStates[b], 'de'));
